import {
  patchState,
  signalStoreFeature,
  withMethods,
  withState,
} from '@ngrx/signals';
import type { EntityIdState } from './entity-form.types';

/**
 * Adds `entityId` state and a `setEntityId()` setter for entity edit forms.
 */
export function withEntityId() {
  return signalStoreFeature(
    withState<EntityIdState>({ entityId: null }),
    withMethods((store) => ({
      setEntityId(entityId: number | null) {
        patchState(store, { entityId });
      },
    }))
  );
}
